<template>
  <div class="redeem">
    <el-dialog
      class="redeem_dialog"
      title="验券并挂号"
      :visible.sync="redeemMap.visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" :model="redeemMap.form" :rules="redeemMap.rules" label-width="90px">
          <el-form-item class="form_item" label="门诊医生" prop="doctorId">
            <el-select class="form_select" v-model="redeemMap.form.doctorId" filterable placeholder="请选择">
              <el-option v-for="doctor in doctorList" :key="doctor.doctorId" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form_item form_item_code" label="核销券码" required>
            <el-input class="form_input" placeholder="输入券码或扫描二维码" v-model.trim="redeemMap.form.voucherCode">
              <div slot="append" :class="{'form_input_btn': true, 'can_click': ![null, undefined, ''].includes(redeemMap.form.voucherCode)}" @click="redeemCode">{{ redeemMap.voucherCodeList.length > 0 ? '继续验券' : '验券' }}</div>
            </el-input>
            <div v-if="redeemMap.voucherCodeList && redeemMap.voucherCodeList.length > 0" class="code_list">
              <div v-for="(code, codeIndex) in redeemMap.voucherCodeList" :key="codeIndex" class="code_item">
                <img class="code_item_icon" :src="imgArr.meituan_ticket" />
                <span class="code_item_text">{{ code.voucherCode }}(已核销)</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="redeem_confirm_dialog"
      title="确认验券"
      :visible.sync="confirmMap.visible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="confirmClose">
      <div class="confirm_content">
        <div class="confirm_tips">
          <span class="el-icon-info confirm_tips_icon"></span>
          <span class="confirm_tips_text">请您核对用户的消费项目并确认验券数量</span>
        </div>
        <div class="confirm_info">
          <div class="confirm_title">团购｜{{ confirmMap.name }}</div>
          <div class="confirm_description">
            <span class="confirm_description_text">剩余</span>
            <span class="confirm_description_num">{{ confirmMap.count }}</span>
            <span class="confirm_description_text">张券可验证</span>
          </div>
          <div class="confirm_count">
            <div class="confirm_count_label">本次验券数量</div>
            <el-input-number class="confirm_count_value" v-model="confirmMap.consumeCount" :step-strictly="true" :min="1" :max="confirmMap.count" @blur="confirmConsumeCountBlur"></el-input-number>
          </div>
        </div>
      </div>
      <div slot="footer" class="confirm_footer">
        <el-button @click="confirmClose">取 消</el-button>
        <el-button type="primary" @click="confirmSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { imgArr } from '@/assets/images/img';
  import { debounce } from '@/utils/validateBase'
  import req from '@/utils/request';
  export default {
    name: 'MeiTuanRedeem',
    data() {
      return {
        imgArr: imgArr,
        loading: false,
        submitLoading: false,
        schedulingTime: '',
        doctorList: [],
        redeemMap: {
          visible: false,
          form: {
            reservationId: '',
            plat: 1,
            doctorId: '',
            voucherCode: ''
          },
          rules: {
            doctorId: [
              { required: true, message: '请选择门诊医生', trigger: 'change' }
            ]
          },
          voucherCodeList: []
        },
        confirmMap: {
          visible: false,
          name: '',
          count: 1,
          voucherCode: '',
          consumeCount: 1
        }
      }
    },
    methods: {
      async getDoctorList () {
        const res = await req.get('/patient/doctor/queryDoctorByScheduling', {
          deptId: window.sessionStorage.getItem('deptId'),
          schedulingTime: this.schedulingTime
        })
        if (res.code === 200) {
          this.doctorList = res.data
        }
      },
      async getDetail () {
        this.loading = true
        const res = await req.get('/physioReservation/detail', {
          id: this.redeemMap.form.reservationId
        })
        this.loading = false
        if (res.code === 200) {
          this.redeemMap.voucherCodeList = res.data.voucherInfos || []
        }
      },
      open (id, schedulingTime) {
        this.schedulingTime = schedulingTime || new Date().Format('yyyy-MM-dd')
        this.redeemMap.form.reservationId = id
        this.redeemMap.visible = true

        this.getDetail()

        this.getDoctorList()
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      },
      close () {
        this.redeemMap.visible = false

        this.redeemMap.form.reservationId = ''
        this.redeemMap.form.doctorId = ''
        this.redeemMap.form.voucherCode = ''
      },
      submit: debounce(function() {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            if (!(this.redeemMap.voucherCodeList && this.redeemMap.voucherCodeList.length > 0)) {
              this.$message.error('请先验券')
              return
            }
            this.submitLoading = true
            const res = await req.post('/physio/group-voucher/submit', {
              reservationId: this.redeemMap.form.reservationId,
              doctorId: this.redeemMap.form.doctorId,
              plat: 1,
              orderSourceType: '0'
            })
            this.submitLoading = false
            if (res.code === 200) {
              this.$message.success('验券并挂号成功')
              this.$emit('submit', this.redeemMap.form.reservationId)
              this.close()
            }
          }
        })
      }, 1000, true),
      async redeemCode () {
        if (!this.redeemMap.form.voucherCode) {
          this.$message.error('请输入券码')
          return
        } else {
          this.loading = true
          const res = await req.post('/physio/group-voucher/valid', {
            deptId: window.sessionStorage.getItem('deptId'),
            plat: 1,
            voucherCode: this.redeemMap.form.voucherCode
          })
          this.loading = false
          if (res.code === 200) {
            window.onkeydown = null

            if (document.activeElement && document.activeElement.blur) {
              document.activeElement.blur();
            }

            this.confirmMap.name = res.data.dealTitle
            this.confirmMap.count = res.data.count
            this.confirmMap.voucherCode = res.data.receiptCode
            this.confirmMap.consumeCount = 1

            this.redeemMap.form.voucherCode = ''

            this.confirmMap.visible = true
          }
        }
      },
      confirmClose () {
        this.confirmMap.visible = false
      },
      confirmConsumeCountBlur () {
        if ([null, undefined, ''].includes(this.confirmMap.consumeCount)) {
          this.confirmMap.consumeCount = 1
        }
      },
      async confirmSubmit () {
        const res = await req.post('/physio/group-voucher/consume', {
          deptId: window.sessionStorage.getItem('deptId'),
          plat: 1,
          reservationId: this.redeemMap.form.reservationId,
          voucherCode: this.confirmMap.voucherCode,
          consumeCount: this.confirmMap.consumeCount
        })
        if (res.code === 200) {
          this.$message.success('验券成功')
          this.confirmClose()
          this.getDetail()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .redeem {}

  .redeem_dialog /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .redeem_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #1F2329;
  }

  .redeem_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .redeem_dialog /deep/ .el-dialog__body {
    padding: 20px 24px;
  }

  .redeem_dialog /deep/ .el-dialog__footer {
    padding: 16px;
  }

  .form_item /deep/ .el-form-item__label {
    line-height: 32px;
  }

  .form_item /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_item_code {
    margin: 0 0 0 0;
  }

  .form_select {
    width: 100%;
  }

  .form_input /deep/ .el-input-group__append {
    padding: 0;
    min-height: 0px;
  }

  .form_input_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 30px;
    cursor: pointer;
    user-select: none;
  }

  .form_input_btn.can_click {
    color: #409eff;
    background-color: #ecf5ff;
  }

  .code_list {
    box-sizing: border-box;
    margin: 12px 0 0 0;
    padding: 10px;
    width: 100%;
    max-height: 160px;
    background-color: #F5F7FA;
    border-radius: 2px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .code_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .code_item + .code_item {
    margin: 6px 0 0 0;
  }

  .code_item_icon {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  }

  .code_item_text {
    margin: 0 0 0 4px;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #1F2329;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .redeem_confirm_dialog /deep/ .el-dialog__footer {
    padding: 16px;
  }

  .confirm_tips {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 18px;
    width: 100%;
    height: 38px;
    background-color: #FFFBE8;
  }

  .confirm_tips_icon {
    font-size: 16px;
    color: #FE8F1F;
  }

  .confirm_tips_text {
    margin: 0 0 0 5px;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
  }

  .confirm_info {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .confirm_title {
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .confirm_description {
    margin: 6px 0 0 0;
    width: 100%;
    line-height: 20px;
  }

  .confirm_description_text {
    font-size: 13px;
    color: #667182;
  }

  .confirm_description_num {
    margin: 0 2px;
    font-size: 13px;
    color: #1890FF;
  }

  .confirm_count {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 10px 0 0 0;
    width: 100%;
  }

  .confirm_count_label {
    font-size: 14px;
    color: #000000;
  }

  .confirm_count_value {
    margin: 0 0 0 12px;
    width: 130px;
  }
</style>